const styles = (theme) => ({
  btnClass: {
    '& > button': {
      padding: '0.4rem',
    },
    justifyContent: 'flex-end',
    display: 'flex',
  },
  btntDiv: {
    paddingLeft: '10px',
  },
  dataCellLast: {
    borderTop: '1px solid #eeeeee',
  },
});

export default styles;
